module.exports = __webpack_public_path__ + "img/37.0334f9fe.png";